import { render, staticRenderFns } from "./exhibitor.vue?vue&type=template&id=f048bfd2&scoped=true"
import script from "./exhibitor.vue?vue&type=script&lang=js"
export * from "./exhibitor.vue?vue&type=script&lang=js"
import style0 from "./exhibitor.vue?vue&type=style&index=0&id=f048bfd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f048bfd2",
  null
  
)

export default component.exports